import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login-index',
    component: () => import('../views/auth/login.vue'),
    meta: { title: 'Đăng nhập QMS' },
  },
  {
    path: '/register',
    name: 'register-index',
    component: () => import('../views/auth/register.vue'),
    meta: { title: 'Đăng ký QMS' },
  },
  {
    path: '/',
    component: () => import('../layouts/AppLayout.vue'),
    meta: { title: 'QMS Center' },
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('../views/mainSite/index.vue'),
        meta: { title: 'Trang chủ' },
      },
      {
        path: 'setting',
        name: 'index-setting',
        component: () => import('../views/mainSite/indexSetting.vue'),
        meta: { title: 'Cài đặt' },
      },
      {
        path: 'review',
        name: 'index-review',
        component: () => import('../views/mainSite/indexReview.vue'),
        meta: { title: 'Đánh giá' },
      },
      {
        path: 'report',
        name: 'index-report',
        component: () => import('../views/mainSite/indexReport.vue'),
        meta: { title: 'Báo cáo' },
      },
      {
        path: 'user',
        name: 'userman-index',
        component: () => import('../views/mainSite/user/user-index.vue'),
        meta: { title: 'Tài khoản' },
      },
      {
        path: 'user/detail/:id',
        name: 'userman-detail',
        component: () => import('../views/mainSite/user/user-detail.vue'),
        meta: { title: 'Chi tiết tài khoản' },
      },
      {
        path: 'user/create',
        name: 'userman-create',
        component: () => import('../views/mainSite/user/user-create.vue'),
        meta: { title: 'Tạo tài khoản' },
      },
      {
        path: 'tivi',
        name: 'tivi-index',
        component: () => import('../views/mainSite/tivi/tivi-index.vue'),
        meta: { title: 'Tivi Android' },
      },
      {
        path: 'tivi/detail/:id',
        name: 'tivi-detail',
        component: () => import('../views/mainSite/tivi/tivi-detail.vue'),
        meta: { title: 'Chi tiết tivi' },
      },
      {
        path: 'tivi/create',
        name: 'tivi-create',
        component: () => import('../views/mainSite/tivi/tivi-create.vue'),
        meta: { title: 'Tạo tivi' },
      },
      {
        path: 'chinhanh',
        name: 'chinhanh-index',
        component: () => import('../views/mainSite/chinhanh/chinhanh-index.vue'),
        meta: { title: 'Chi nhánh' },
      },
      {
        path: 'chinhanh/detail/:id',
        name: 'chinhanh-detail',
        component: () => import('../views/mainSite/chinhanh/chinhanh-detail.vue'),
        meta: { title: 'Chi tiết chi nhánh' },
      },
      {
        path: 'chinhanh/create',
        name: 'chinhanh-create',
        component: () => import('../views/mainSite/chinhanh/chinhanh-create.vue'),
        meta: { title: 'Tạo chi nhánh' },
      },
      {
        path: 'goiten-index',
        name: 'goiten-index',
        component: () => import('../views/mainSite/goiten/goiten.index.vue'),
        meta: { title: 'Gọi tên' },
      },
      {
        path: 'ipwan',
        name: 'ipwan-index',
        component: () => import('../views/mainSite/ipwan/ipwan-index.vue'),
        meta: { title: 'IP WAN' },
      },
      {
        path: 'ipwan/detail/:ip',
        name: 'ipwan-detail',
        component: () => import('../views/mainSite/ipwan/ipwan-detail.vue'),
        meta: { title: 'Chi tiết IP WAN' },
      },
      {
        path: 'ipwan/create',
        name: 'ipwan-create',
        component: () => import('../views/mainSite/ipwan/ipwan-create.vue'),
        meta: { title: 'Tạo IP WAN' },
      },
      {
        path: 'cccd',
        name: 'cccd-create',
        component: () => import('../views/mainSite/chuyendoicancuoc/chuyendoicancuoc.vue'),
        meta: { title: 'Đọc CCCD' },
      },
      {
        path: 'convertexcel',
        name: 'convertexcel-index',
        component: () => import('../views/mainSite/utility/convertexcel.vue'),
        meta: { title: 'Chuyển Excel -> Json' },
      },
      {
        path: 'splitpdf',
        name: 'splitpdf-index',
        component: () => import('../views/mainSite/utility/splitpdfzip.vue'),
        meta: { title: 'Tách PDF -> ZIP' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.afterEach((to) => {
  if (to.meta?.title) {
    document.title = `${to.meta.title} | QMS Center`
  }
})

export default router
